import { create } from 'zustand'
import type { Role } from '../auth/roles'

export type User = {
  id:       string
  name:     string
  role:     Role
  tenantId: string
}

type AuthState = {
  user:       User | null
  loading:    boolean
  setUser:    (u: User | null) => void
  setLoading: (v: boolean) => void
  logout:     () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user:       null,
  loading:    true,
  setUser:    (u) => set({ user: u }),
  setLoading: (v) => set({ loading: v }),
  logout:     ()  => set({ user: null, loading: false }),
}))